<template>
  <div
    :title="params.name ? params.name : params.displayName"
    class="attendanceheader__title"
  >
    <div
      v-if="params.link"
      class="link"
      @click="openLink"
    >
      <span style="color: #b71c1c"> {{ params.name }} </span>
      <br>
      <small style="font-style:italic; font-weight:normal">{{ params.date }}</small>
    </div>
    <div v-else>
      {{ params.displayName }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'AttendanceMatrixHeader',

  data () {
    return {
      params: null,
    }
  },

  methods: {
    openLink () {
      window.open(this.params.link)
    },
  },
})
</script>

<style lang="scss">
    .attendanceheader__title {
        font-size: 14px;
        padding: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
        cursor: pointer;

        .link {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
</style>
